import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';

import { ManageInventoryService } from '../shared';
import { DEVICE_DEPLOYMENT_SUMMARY, CHART_CONFIG } from 'config';
import { UtilityService } from 'lib/ng2-sapmp/src/providers';
import { BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { FormBuilder } from '@angular/forms';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { KEY_CONFIG } from 'lib/ng2-sapmp/src/config/key-config';
import {  FormGroup, FormControl, Validators} from '@angular/forms';
import { ConfirmedValidator } from './confirmed.validator';
import { interval, of } from 'rxjs';
import { filter, mergeMap, takeUntil, tap } from 'rxjs/operators';
declare var logoutCurrentUser: any;

import { ViewChild, ElementRef } from '@angular/core';


@Component({
  selector: 'app-manage-accounts',
  templateUrl: './manage-accounts.component.html',
  styleUrls: ['./manage-accounts.component.scss'],
  providers: [ManageInventoryService]
})

export class ManageAccountsComponent implements OnInit {
  manageAccounts: any;
  //isDisabled: boolean = false;
  moveDevices: boolean = false;
  moveDevicesFlag: boolean = false;
  showErrors: boolean = false;
  formSuccess = false;
  failuremessage:boolean = false;
  form: FormGroup = new FormGroup({});
  fan:any;
  currentorgid:any;
  existingroute:any;
  tranid: any;
  setupError:boolean = false;
  errorMessage:any;
  timerStart: any;
  signUpStatus:any;
    
  constructor(private utilityService: UtilityService, private router: Router, private breadCrumbService: BreadCrumbService, 
    private formBuilder: FormBuilder, private route: ActivatedRoute, private manageInventoryService: ManageInventoryService,
    private pageloaderService: PageLoaderService) {
      this.form = formBuilder.group({
        appleorgid: ['', [Validators.required]],
        confirmappleorgid: ['', [Validators.required]]
      }, { 
        validator: ConfirmedValidator('appleorgid', 'confirmappleorgid')
      })
  }
  get f(){
    return this.form.controls;
  }
   
  
  @ViewChild('submitButton') submitButton:ElementRef;

  ngOnInit() {
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.breadCrumbService.setStaticBreadCrumbs('/manageInventory');
    this.breadCrumbService.setCurrentBreadCrumb({ label: 'Manage accounts', routerLink: '/manageInventory' });
    this.breadCrumbService.setCurrentBreadCrumb({ label: 'Edit Apple Organization ID', routerLink: '/manageAccounts' });
 
    this.manageAccounts = this.route.snapshot.data.pageData.manageInventorymanageAccounts;
    //this.isDisabled = true;
    this.showErrors = false;
    this.pageloaderService.setPageLoaderStatus(true);
    
    this.fan = sessionStorage.getItem("FAN");
    console.log(this.fan);
    // this.currentorgid = sessionStorage.getItem("OrgID");
    // console.log(this.currentorgid);
    
    // this.existingroute = sessionStorage.getItem("currentRoute");
    this.existingroute = sessionStorage.getItem("previousRoute");
    
  }
  
  toggleTooltip(event) {
    if (event.type !== 'click') {
      if (event.keyCode !== KEY_CONFIG.enter) {
        return;
      }
    }
    let targetElement = event.target;
    const elems = document.querySelectorAll('.tooltipActive');
    let iselementActive = false;
    if (targetElement.classList.contains('tooltipActive')) {
      iselementActive = true;
    }
    [].forEach.call(elems, function (ele) {
      ele.classList.remove('tooltipActive');
    });
    if (iselementActive) {
      targetElement.classList.remove('tooltipActive');
    } else {
      targetElement.classList.add('tooltipActive');
    }
  }

  toggleTooltipEnter(event) {
    if (event.type !== 'mouseenter') {
      if (event.keyCode !== KEY_CONFIG.enter) {
        return;
      }
    }
    let targetElement = event.target;
    const elems = document.querySelectorAll('.tooltipActive');
    let iselementActive = false;
    if (targetElement.classList.contains('tooltipActive')) {
      iselementActive = true;
    }
    [].forEach.call(elems, function (ele) {
      ele.classList.remove('tooltipActive');
    });
    if (iselementActive) {
      targetElement.classList.remove('tooltipActive');
    } else {
      targetElement.classList.add('tooltipActive');
    }
  }

  toggleTooltipLeave(event) {
    if (event.type !== 'mouseleave') {
      if (event.keyCode !== KEY_CONFIG.enter) {
        return;
      }
    }
    let targetElement = event.target;
    const elems = document.querySelectorAll('.tooltipActive');
    let iselementActive = false;
    if (targetElement.classList.contains('tooltipActive')) {
      iselementActive = true;
    }
    [].forEach.call(elems, function (ele) {
      ele.classList.remove('tooltipActive');
    });
    if (iselementActive) {
      targetElement.classList.remove('tooltipActive');
    } else {
      targetElement.classList.add('tooltipActive');
    }
  }
  
  continueToNext() {

    //orgid 

    if(this.existingroute === '/manageInventory/deviceInventory'){
      this.currentorgid = sessionStorage.getItem('DeviceinventoryOrgId');
      console.log(this.currentorgid);
    }
    else if(this.existingroute === '/manageInventory'){
      this.currentorgid = sessionStorage.getItem('OrgID');
      console.log(this.currentorgid);
    }
    
    if(this.currentorgid === this.form.value.confirmappleorgid ){
        this.pageloaderService.setPageLoaderStatus(true);
        this.showErrors = true;
        this.submitButton.nativeElement.disabled = true;    
    }
    else{
     
    //org id validation
    this.manageInventoryService.orgIdValidation(this.form.value.confirmappleorgid)
    .subscribe(response => {
      this.pageloaderService.setPageLoaderStatus(false);
      if(response.status === 'success') {
      let data = response;
      this.tranid = data.deviceEnrollmentTransactionId;
      console.log(this.tranid);
     
      //transaction id validation
      let poll$ = interval(5000).pipe(
        mergeMap(obs => 
          this.manageInventoryService.tranIdValidation(this.tranid)),
          tap(data => console.log(data))
      );

      const until$ = poll$.pipe(
        filter(data => {
          let status: boolean;
          if(data.status === 'success') {
            status = true;
            this.pageloaderService.setPageLoaderStatus(false);
            this.setupError = false;
           
           console.log(this.form.value.appleorgid);
           console.log(this.form.value.confirmappleorgid);
          //  if (this.moveDevices) {
          //    this.moveDevicesFlag = true;
          //  } else {
          //    this.moveDevicesFlag = false;
          //  } 
          this.moveDevicesFlag = false;
           let data = {
             "fanNo":this.fan.toString(),
             "emmProductCode":"DMPAABM",
             "oldOrgId" : this.currentorgid,
             "newOrgId" : this.form.value.confirmappleorgid,
             "moveDevices" : this.moveDevicesFlag.toString()
           }
          console.log(data);
           this.manageInventoryService.postappleorgdata(data)
           .subscribe(
           res => {
                 if(this.existingroute === '/manageInventory/deviceInventory'){
                   this.router.navigate(['/manageInventory/deviceInventory']);
                   sessionStorage.setItem('resorgidSuccess','true'); 
                  // this.formSuccess = true;
                 }
                 else if(this.existingroute === '/manageInventory'){
                 this.router.navigate(['/manageInventory']);
                 sessionStorage.setItem('resorgidSuccess','true'); 
                 // this.formSuccess = true;
                  console.log(res);
                }
             else{
              sessionStorage.setItem('resorgidSuccess','false'); 
               this.failuremessage = true;
             }
             
           }), error => {
             this.failuremessage = true;
            };
          
          
          } else if (data.status === 'failure') {
            status = true;
            this.pageloaderService.setPageLoaderStatus(true);
            this.setupError = true;
            this.errorMessage = 'We were unable to validate your Apple Organization ID.  Please validate the ID from within your Apple Business profile and try again.'
            this.utilityService.loadFocusOnTop();

          } else {
            let time = Date.now() - this.timerStart;
            status = (time > 60000);
            if (status) {
              this.pageloaderService.setPageLoaderStatus(true);
              this.setupError = true;
              this.errorMessage = data.ErrorDescription;
              this.utilityService.loadFocusOnTop();
            }
          }
          return status;
        })
      );
    
      const data$ = poll$.pipe(
        takeUntil(until$))
        .subscribe();

      this.timerStart = Date.now();

    } else {
      this.pageloaderService.setPageLoaderStatus(true);
      this.errorMessage = 'Apple Org ID validation failed. Please try again.';
      this.setupError = true;
      this.utilityService.loadFocusOnTop();
    }
  }, error => {
    this.pageloaderService.setPageLoaderStatus(true);
    this.setupError = true;
    this.handleError(error);
    this.utilityService.loadFocusOnTop();
  });
  
}

 }

 handleError = (err) => {
  if (err) {
    if (err.status === 500) {
      this.errorMessage = "Something went wrong. We couldn't process your request. Please try again later.";
    } else if (err.status === 401) {
      this.errorMessage = 'Session expired, Please login again.';
      logoutCurrentUser(true);
    } else if (err.status === 400) {
      this.errorMessage = 'Id is already in the system.';
    } else if (err.status === 404) {
      this.errorMessage = "Something went wrong. We couldn't process your request. Please try again later.";
    } else if (this.signUpStatus === 'failure') { // remove this block after it is integrated wit the servce this is only for demo
      this.errorMessage = "Something went wrong. We couldn't process your request. Please try again later.";
    } else {
      this.errorMessage = "Something went wrong. We couldn't process your request. Please try again later.";
    }
    this.utilityService.loadFocusOnTop();
  }
}

dismissInfo() {
  this.setupError = false;
  this.showErrors = false;
  this.failuremessage = false;
}
 
  // continueToNext() {
  //   if(this.currentorgid === this.form.value.confirmappleorgid ){
  //     this.showErrors = true;
  //   }else{
  //   console.log(this.form.value.appleorgid);
  //   console.log(this.form.value.confirmappleorgid);
  //   if (this.moveDevices) {
  //     this.moveDevicesFlag = true;
  //   } else {
  //     this.moveDevicesFlag = false;
  //   }
    
  //   let data = {
  //     "fanNo":this.fan,
  //     "emmProductCode":"DMPAABM",
  //     "oldOrgId" : this.currentorgid,
  //     "newOrgId" : this.form.value.confirmappleorgid,
  //     "moveDevices" : this.moveDevicesFlag.toString()
  //   }
  //  console.log(data);
  //   this.manageInventoryService.postappleorgdata(data)
  //   .subscribe(
  //   res => {
  //      if(res.status === 'success'){
  //         if(this.existingroute === '/manageInventory/deviceInventory'){
  //           this.router.navigate(['/manageInventory/deviceInventory']);
  //           this.formSuccess = true;
  //           console.log(res); 
  //         }else{
  //         this.router.navigate(['/manageInventory']);
  //           this.formSuccess = true;
  //         console.log(res);
  //        }
  //     }else{
  //       this.failuremessage = true;
  //     }
      
  //   })
  //   }

  // }

}